import { Flex, Text, IconButton, Select } from "@chakra-ui/react";
import { ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  pageSize: number;
  isQuerying: boolean;
  onPageChange: (page: number) => void;
  onPageSizeChange: (size: number) => void;
  pageSizeOptions?: number[];
}

export default function Pagination({
  currentPage,
  totalPages,
  pageSize,
  isQuerying,
  onPageChange,
  onPageSizeChange,
  pageSizeOptions = [5, 10, 20, 50],
}: PaginationProps) {
  const safeTotalPages = Math.max(totalPages, 1);

  return (
    <Flex
      justifyContent="center"
      mt={1}
      alignItems="center"
      flexWrap="wrap"
      gap={2}
      p={3}
      w="100%"
    >
      <Flex alignItems="center" gap={3}>
        <IconButton
          icon={<ChevronLeftIcon boxSize={5} />}
          aria-label="Página Anterior"
          onClick={() => onPageChange(currentPage - 1)}
          isDisabled={isQuerying || currentPage <= 1}
          size="md"
          variant="outline"
          borderRadius="lg"
          colorScheme="gray"
          _hover={{
            bg: "gray.100",
            borderColor: "primary",
          }}
        />
        
        <Flex alignItems="center" gap={2}>
          <Text fontSize="sm" fontWeight="medium" color="gray.600">
            Página
          </Text>
          <Text
            fontSize="md"
            fontWeight="bold"
            color="primary"
          >
            {currentPage}
          </Text>
          <Text fontSize="sm" fontWeight="medium" color="gray.600">
            de
          </Text>
          <Text
            fontSize="md"
            fontWeight="semibold"
            color="gray.700"
          >
            {safeTotalPages}
          </Text>
        </Flex>

        <IconButton
          icon={<ChevronRightIcon boxSize={5} />}
          aria-label="Próxima Página"
          onClick={() => onPageChange(currentPage + 1)}
          isDisabled={isQuerying || currentPage >= safeTotalPages}
          size="md"
          variant="outline"
          borderRadius="lg"
          colorScheme="gray"
          _hover={{
            bg: "gray.100",
            borderColor: "primary",
          }}
        />
      </Flex>

      <Flex alignItems="center" gap={2} ml={{ base: 0, md: 4 }}>
        <Text fontSize="sm" fontWeight="medium" color="gray.600">
          Itens por página:
        </Text>
        <Select
          width="80px"
          size="md"
          borderRadius="lg"
          value={pageSize}
          onChange={(e) => onPageSizeChange(Number(e.target.value))}
          isDisabled={isQuerying}
          fontWeight="medium"
          _hover={{
            borderColor: "primary",
          }}
          _focus={{
            borderColor: "primary",
            boxShadow: "0 0 0 1px var(--chakra-colors-primary)",
          }}
        >
          {pageSizeOptions.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </Select>
      </Flex>
    </Flex>
  );
}
